import { DoctorInfoReq } from "../components/Shared/Sms/Sms.model";
import { smsService } from "../components/Shared/Sms/Sms.service";
import { utilService } from "./utilService";
import { BehaviorSubject } from "rxjs";

let loggedInUserDataDetails: any;
let loggedInUserData = new BehaviorSubject("");
let getLoggedInUserData = loggedInUserData.asObservable();

var setLoggedInUserData = async () => {
  const params: DoctorInfoReq = paramsDoctorInfo();
  const respDoctorListResult: any = await smsService.getDoctorInformation(
    params
  );
  if (respDoctorListResult.isSuccess) {
    loggedInUserDataDetails = respDoctorListResult.result;
    loggedInUserData.next(respDoctorListResult.result);
    console.log(loggedInUserData);
  } else {
    console.log("error");
    smsService.handleErrorResponse();
  }
};

const paramsDoctorInfo = () => {
  return {
    guid: utilService.getLoggedUserGuid(),
    reg_code: utilService.getNetwork(),
  };
};

export const loggedInUserService = {
  setLoggedInUserData,
  loggedInUserData,
  loggedInUserDataDetails,
  getLoggedInUserData,
};
